import { Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { t } from 'i18next'
import React from 'react'
import PhoneInput from 'react-phone-number-input'
import ZipCodeSearchField from '../../Public/Appointment/ZipCodeSearchField'
const { RangePicker } = DatePicker

export default function PatientAppointmentForm ({ form, onDateChange, rangeDisable }) {
  return (
    <>
      <Row gutter={16}>
        <Col>
          <Form.Item name="appointment_date" label={t('Admin.AppointmentForm.appointment_date')} >
            <DatePicker
              format={'DD/MM/YY HH[h]mm'}
              disabled />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="range" label={t('Admin.AppointmentForm.range')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <RangePicker
              onChange={onDateChange}
              showTime={{ format: 'HH[h]mm' }}
              format={'DD/MM/YY HH[h]mm'}
              disabled={rangeDisable} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="first_name" label={t('Admin.AppointmentForm.first_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="last_name" label={t('Admin.AppointmentForm.last_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="age" label={t('Admin.AppointmentForm.age')}
            rules={[{ required: true, message: t('rules.required') }]}
            extra={t('Admin.AppointmentForm.age_extra')} >
            <InputNumber min={0} max={150} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col style={{ maxWidth: '25%' }}>
          <Form.Item name="phone" label={t('Admin.AppointmentForm.phone')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <PhoneInput className='ant-input css-dev-only-do-not-override-xfszwz'
              international defaultCountry={'FR'}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="email" label={t('Admin.AppointmentForm.email')}>
            <Input />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="postal_place_id" label={t('Admin.AppointmentForm.zip_code')}>
            <ZipCodeSearchField form={form} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="comment" label={t('Admin.AppointmentForm.comment')}>
        <TextArea rows={5} />
      </Form.Item>
      <Form.Item name="is_now">
        <Input type='hidden' />
      </Form.Item>
    </>
  )
}
